import { useRetailerContext } from '@/features/shared/context/RetailerContext'
import { useLegacyStoreParams } from '@/features/shared/utils/dataFetching/legacyStoreParams'

export const useStoreParams = (): StoreParams => {
  const value = useRetailerContext()
  // fallback if we are not within store context
  const params = useLegacyStoreParams()

  if (!value) {
    return params
  }
  return value.storeParams
}

export type StoreParams = {
  /**
   * @deprecated user_id should only be accessed from user hooks e.g. useUser, useUserId, etc
   */
  user_id: number
  /**
   * @deprecated zip should only be accessed from user hooks e.g. useUser, useUserZip, etc
   */
  zip: string
  metro_id: number | null
  store_id: number | null
  store_location_id: number | null
}

export type StoreParamsAsKey = {
  storeParams: StoreParams
}

export type StoreLocationParams = {
  metro_id?: number | null
  store_id?: number | null
  store_location_id?: number | null
}
